import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum.js';
import TpEvaluatorItem from '../../../Domain/TpEvaluatorItem.js';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable.js';
import TpEvaluatorService from '../../../Services/TpEvaluatorService.js';
import TpEvaluatorSearchParams from './TpEvaluatorSearchParams.js';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum.js';
import GenericOverWindow from '../../../Elements/TabList/GenericOverWindow.js';
import RelatedTpJobWindowDescription from './RelatedTpJobWindowDescription.js';
import TipaltiProfileWindowDescription from './TipaltiProfileWIndowDescription.js';
import RelatedTpEvaluatorTpJobPaymentsWindowDescription from './RelatedTpEvaluatorTpJobPaymentsWindowDescription.js';

export default class TpEvaluatorAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    TpEvaluatorItem.tipaltiEditReviewFunction = this.tipaltiEditReviewFunction.bind(this);
    TpEvaluatorItem.ListJobsFunction = this.ListJobsFunction.bind(this);
    TpEvaluatorItem.ListEvaluatorPaymentsFunction = this.ListEvaluatorPaymentsFunction.bind(this);
    // CD-5527: the detail popup's "Linked TP Evaluators" tab links/detaches profiles while the popup stays
    // open; it flags the change here and the list is re-fetched when the popup closes (afterClickOnCancel).
    TpEvaluatorItem.linkingChangedFunction = () => {
      this.linkingChanged = true;
    };
    this.linkingChanged = false;

    TipaltiProfileWindowDescription.getFilterParameters = this.getRelatedJobsFilterParameters.bind(this);
    RelatedTpEvaluatorTpJobPaymentsWindowDescription.getFilterParameters =
      this.getRelatedJobsFilterParameters.bind(this);

    this.closeOverWindow = this.closeOverWindow.bind(this);

    const searchItem = new TpEvaluatorSearchParams();

    // Deep-link seed for global record search (CD-5425), on email rather than name: names repeat across
    // third-party sources, and this grid filters email exactly.
    const seededEmail = new URLSearchParams(window.location.search).get('Email');
    if (seededEmail) {
      searchItem.Email = seededEmail;
    }

    this.state = {
      searchItem,
      itemList: [],
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
      // cleared: !searchItem.Id,
      // A production build opens the grid empty until the user searches, except for a deep link, which
      // already carries its search (CD-5425) and would otherwise wait for a Search click.
      cleared: process.env.NODE_ENV !== 'development' && !searchItem.Id && !seededEmail,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
    this.refresh = this.refresh.bind(this);
    this.onDetailPopupClose = this.onDetailPopupClose.bind(this);
  }

  onDetailPopupClose() {
    if (this.linkingChanged) {
      this.linkingChanged = false;
      this.refresh();
    }
  }

  // selectAllElements() {
  //   const selectedStatus = this.state.itemList.some((item) => item.Selected === false);

  //   const templist = [...this.state.itemList];

  //   if (templist !== undefined && templist.length > 0) {
  //     templist.map((c) => (c.Selected = selectedStatus));
  //   }
  //   this.setState({ itemList: templist });
  // }

  // selectedStatus() {
  //   return !this.state.itemList.some((x) => x.Selected === false);
  // }

  // activateFunction(id) {
  //   TpEvaluatorService.ActivateItem(id)
  //     .then(() => this.refresh())
  //     .catch(() => ErrorMessage.SetErrorMessage('TDEEA65'));
  // }

  getRelatedJobsFilterParameters() {
    return {
      tpEvaluatorId: this.state.selectedItem?.TpEvaluatorId,
      evaluatorId: this.state.selectedItem?.EvaluatorId,
      evaluatorSassieId: this.state.selectedItem?.EvaluatorSassieId,
      TipaltiId: this.state.selectedItem?.TipaltiId,
      name: this.state.selectedItem?.Name,
    };
  }

  tipaltiEditReviewFunction(id, evaluator, evaluatorList) {
    this.setState({
      selectedItem: evaluator,
      shownOverWindow: ShownOverWindowsEnum.TipaltiEvaluatorData,
    });
  }

  ListJobsFunction(item) {
    this.setState({
      selectedItem: item,
      shownOverWindow: ShownOverWindowsEnum.AssignmentsList,
    });
  }

  ListEvaluatorPaymentsFunction(item) {
    this.setState({
      selectedItem: item,
      shownOverWindow: ShownOverWindowsEnum.EvaluatorPayments,
    });
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem }, cleared: false });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.TipaltiEvaluatorData) {
      return (
        <GenericOverWindow
          windowDescription={TipaltiProfileWindowDescription}
          clickOnCancel={this.closeOverWindow}
        />
      );
    }
    if (this.state.shownOverWindow === ShownOverWindowsEnum.AssignmentsList) {
      return (
        <GenericOverWindow
          windowDescription={RelatedTpJobWindowDescription}
          filterParameters={this.getRelatedJobsFilterParameters()}
          clickOnCancel={() => this.setState({ shownOverWindow: ShownOverWindowsEnum.None })}
        />
      );
    }
    if (this.state.shownOverWindow === ShownOverWindowsEnum.EvaluatorPayments) {
      return (
        <GenericOverWindow
          windowDescription={RelatedTpEvaluatorTpJobPaymentsWindowDescription}
          clickOnCancel={() => this.setState({ shownOverWindow: ShownOverWindowsEnum.None })}
        />
      );
    }
    return null;
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, cleared: false });
  }

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  renderButtons() {
    return (
      <div>
        {/* <FigmaButtonRow
          buttons={[
            {
              iconName: 'fa-regular fa-toggle-on',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnBulkStatusChangeApprove('Active'),
              tooltip: 'Activate',
              disabled: !this.state.itemList.some((x) => x.Selected === true && x.Status === 'Ignored'),
            },
            {
              iconName: 'fa-regular fa-toggle-off',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnBulkStatusChangeApprove('Ignored'),
              tooltip: 'Ignore',
              disabled: !this.state.itemList.some((x) => x.Selected === true && x.Status === 'Active'),
            },
          ]}
        /> */}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          afterClickOnCancel={this.onDetailPopupClose}
          clickOnStartSearch={this.startSearch}
          searchParamsType={TpEvaluatorSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={TpEvaluatorService.GetAllItemBySearching}
          convertDBItemsFunction={TpEvaluatorService.ConvertDBItems}
          shownPanel={this.state.shownPanel}
          type={TpEvaluatorItem}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='TEA132'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          cleared={this.state.cleared}
        />
        {this.renderOverWindows()}
      </div>
    );
  }
}
